import Lottie from 'react-lottie-player';
import PropTypes from 'prop-types';

import LoaderAnimation from '../Datas/Loaderdata.json'

const Loader = ({ extraClasses }) => {
  return (
    <div className={`w-full h-screen ${extraClasses}`}>
      <div className='flex flex-col justify-center items-center gap-4 w-full h-full'>
        <Lottie
          animationData={LoaderAnimation}
          loop
          play
          className='w-[4vw] h-[60px] mx-auto'
          style={{height:'6vh',marginTop:'25%'}}
        />
      </div>
    </div>
  );
};

Loader.propTypes = {
  extraClasses: PropTypes.string,
};

export default Loader;